/* hs-eslint ignored failing-rules */

/* eslint-disable prefer-promise-reject-errors */
'use es6';

import { createClient } from 'laboratory-lib';
import { reportError } from '../utils/errorUtils';
export const laboratory = ({
  portalId,
  treatmentKey,
  parameterKey,
  redirectOptions = {},
  shouldLogExposure = false
} = {}) => {
  const treatmentsClient = createClient({
    treatments: {
      [treatmentKey]: {
        identifier: portalId,
        parameters: {
          [parameterKey]: Object.keys(redirectOptions)
        }
      }
    }
  });

  if (shouldLogExposure) {
    treatmentsClient.logExposure(treatmentKey);
  }

  return new Promise((resolvePromise, rejectPromise) => {
    treatmentsClient.resolve(treatments => {
      const treatment = treatments[treatmentKey];
      const extraErrorData = {
        parameterKey,
        portalId,
        treatmentKey
      };

      if (!treatment) {
        reportError(`treatment:${treatmentKey} not found`, extraErrorData);
        return rejectPromise(`treatment:${treatmentKey} not found`);
      }

      const parameter = treatment.parameters[parameterKey];
      const redirectOption = redirectOptions[parameter];
      extraErrorData.redirectOption = redirectOption;

      if (!redirectOption) {
        reportError('redirect option not found', extraErrorData);
        return rejectPromise('redirect option not found');
      }

      if (!redirectOption.url) {
        reportError("redirect option's url not found", extraErrorData);
        return rejectPromise("redirect option's url not found");
      }

      const resolvingObject = {
        url: redirectOption.url
      };

      if (redirectOption.onboardingKey) {
        resolvingObject.onboardingKey = redirectOption.onboardingKey;
      }

      if (redirectOption.groupKey) {
        resolvingObject.groupKey = redirectOption.groupKey;
      }

      if (redirectOption.views) {
        resolvingObject.views = redirectOption.views;
      }

      if (redirectOption.view) {
        resolvingObject.view = redirectOption.view;
      }

      if (redirectOption.enroll) {
        resolvingObject.enroll = true;
      }

      if (redirectOption.beforeRedirect) {
        return redirectOption.beforeRedirect().finally(() => resolvePromise(resolvingObject));
      }

      return resolvePromise(resolvingObject);
    });
  });
};